import React from "react";
import { PawPrint } from "lucide-react";

import PetGroomingService from "../PetGroomingService";
import PetTrainingExperience from "../PetTrainingExperience";
import PetPromoBanner from "../PetPromoBanner";
import PromoBanner from "../PetSectionComponents.tsx/PromoBanner";
import WellnessBanner from "../PetSectionComponents.tsx/WellnessBanner";
import PawShapeCard from "../ServiceCategoryCard";
import Carousel from "../Carousel";

interface ServiceSectionRendererProps {
  section: any;
  servicesItems: any[];
  ImagePath: any;
  handlers: any;
}

export const ServiceSectionRenderer: React.FC<ServiceSectionRendererProps> = ({
  section,
  servicesItems,
  ImagePath,
  handlers,
}) => {
  const sectionType = section?.sectionType ?? section?.sectionName;

  switch (sectionType) {
    // =========================================================
    // MAIN CAROUSEL
    // =========================================================

 case "MainCarousel": {
      if (!section?.data?.length) {
        return null;
      }

      return (
        <div className="w-full overflow-hidden rounded-xl">
          <Carousel
            items={section.data}
            onItemClick={(item) => handlers.onBannerClick?.(item)}
          />
        </div>
      );
    }

    // MainCarousel is handled by the common banner renderer.
    // We intentionally don't render it here.

    // =========================================================
    // SERVICES CATEGORY
case "ServicesCategorySection": {
  const normalizedItems = (section?.data || []).map(
    (item: Record<string, any>) => ({
      id: item.id ?? item.Id ?? item._id,
      name:
        item.name ??
        item.Title ??
        item.Name ??
        "Service",
      image:
        item.logoUrl ??
        item.ImageUrl ??
        item.image ??
        "",
      redirectUrl:
        item.RedirectUrl ??
        item.redirectUrl ??
        null,
      itemType:
        item.ItemType ||
        item.itemType ||
        (section?.contentType === "Custom"
          ? "Custom"
          : "Standard"),
      serviceType: item.serviceType,
      raw: item,
    })
  );

  return (
    <section
      aria-labelledby="services-heading"
      className="w-full max-w-7xl mx-auto px-4"
    >

      {/* ==================================================
          HEADING
      ================================================== */}

      <div className="
        flex
        items-center
        justify-center
        gap-2
        pb-6
        text-center
      ">
        <PawPrint
          size={24}
          className="text-mainBrandColor shrink-0"
        />

        <h3
          id="services-heading"
          className="
            text-xl
            md:text-2xl
            font-semibold
            text-logoHeading
          "
        >
          Choose a Service for Your Pet
        </h3>
      </div>

      {/* ==================================================
          SERVICE GRID
      ================================================== */}

      <div className="
        flex
        flex-wrap
        justify-center
        gap-5
        sm:gap-6
        md:gap-8
      ">

        {normalizedItems.map((item: any) => (
          <div
            key={item.id}
            className="
              w-[200px]
              sm:w-[210px]
              md:w-[230px]
              flex
              justify-center
            "
          >
            <PawShapeCard
              image={item.image}
              name={item.name}
              onClick={() =>
                handlers?.handleBookGroomingClick(item)
              }
            />
          </div>
        ))}

      </div>

    </section>
  );
}

    // =========================================================
    // PET TRAINING
    // =========================================================

    case "PetTrainingExperience":
      return (
        <PetTrainingExperience
          handlePetTrainingClick={handlers.handlePetTrainingClick}
        />
      );

    // =========================================================
    // PROMO BANNER
    // =========================================================

    case "PromoBanner":
      return <PromoBanner onPromoClick={handlers.onPromoClick} />;

    // =========================================================
    // PET GROOMING
    // =========================================================

    case "PetGroomingService":
      return (
        <PetGroomingService
          handleBookClick={(id) => handlers.onBookGrooming(id)}
        />
      );

    // =========================================================
    // PET PROMO BANNER
    // =========================================================

    case "PetPromoBanner": {
      const imageUrl = section?.data?.length
        ? section.data[0].imageUrl
        : ImagePath?.PetTaxiBanner;

      return (
        <PetPromoBanner
          imageUrl={imageUrl}
          onClick={handlers.handlePetTaxiBannerClick}
          sponsoredText="sponsored"
        />
      );
    }

    // =========================================================
    // WELLNESS
    // =========================================================

    case "WellnessBanner":
      return (
        <WellnessBanner
          title="Annual UAE"
          highlightText="Wellness Pass"
          description="Everything your pet needs to thrive in Dubai’s climate, from hydration checks to heat-stroke prevention."
          price="AED 4,000"
          savingsText="Save 800 AED annually"
          image="https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=1200&q=80"
        />
      );

    // =========================================================
    // UNKNOWN
    // =========================================================

    default:
  ;

      return null;
  }
};
